import React, { Component } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps";
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class Map extends Component {
  constructor(props) {
    super(props);

    this.handleGeoClick.bind(this);
  }

  handleGeoClick(geoObj, province) {
    const { tier } = this.props;
    
    fetch('/api/prefectures?filter[name]=' + encodeURIComponent(geoObj.name)).then((resp) => resp.json())
      .then((respJson) => {
        respJson.data.forEach((item) => {
          fetch(item.relationships.province.links.related).then((resp) => resp.json())
            .then((respJson) => {
              if(respJson.data.attributes.name === province) {
                window.location.href = "/find_comparable_markets/tier/" + tier + 
                  "/prefecture/" + item.id;
              }
            });
        });
      });
  }

  getColor(province, geoName) {
    const { prefectureTiers } = this.props; 
    let tier = null;
    let color = "#ECEFF1";

    prefectureTiers.forEach((prefecture) => {
      if(prefecture.name === geoName && prefecture.province === province) {
        tier = prefecture.tier 
      } 
    });

    if(tier === parseInt(this.props.tier)) {
      switch(tier) {
        case 1:   color = "#DC3545"; 
                  break;
        case 2:   color = "#E25340";
                  break;
        case 3:   color = "#FFC107";
                  break;
        case 4:   color = "#29A645";
                  break;
        default:  break;
      } 
    }

    return color;
  }

  getPrefectureCount() {
    const { tier, prefectureTiers } = this.props; 
    let count = 0; 

    if(prefectureTiers) {
      prefectureTiers.forEach((prefecture) => {
        if(prefecture.tier === parseInt(tier)) {
          count++; 
        } 
      });
    }

    return count;
  }

  render() {
    const { prefectureTiers } = this.props;

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          There are {this.getPrefectureCount()} prefectures in Tier {this.props.tier}.
        </CardHeader>
        <CardBody className="p-0">
          { prefectureTiers ?
            <div className="w-100 my-0 mx-auto">
              <ComposableMap
                projectionConfig={{
                  scale: 1000,
                  rotation: [-11,0,0],
                }}
                width={980}
                height={650}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                >
                <ZoomableGroup center={[105,37]} disablePanning>
                  <Geographies geography={"/geographies/ChinaAllPrefectures.json"} disableOptimization>
                    {(geographies, projection) => geographies.map((geography, i) => {
                      if(geography.id !== "ATA") {
                        let defaultFill = "#ECEFF1";

                        if(geography.properties.notAvailable) {
                          return (
                            <Geography
                              key={i}
                              id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                              geography={geography}
                              projection={projection}
                              style={{
                                default: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                                hover: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  opacity: 0.3,
                                  outline: "none",
                                },
                              }}
                            >
                              <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                                {geography.properties.name} (Coming Soon)
                              </UncontrolledTooltip>
                            </Geography>
                          ); 
                        } else {
                          return (
                            <Geography
                              key={i}
                              id={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}
                              geography={geography}
                              projection={projection}
                              onClick={(geo) => this.handleGeoClick(geo.properties, geo.properties.province)}
                              style={{
                                default: {
                                  fill: prefectureTiers ? this.getColor(geography.properties.province, geography.properties.name) : defaultFill,
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                                hover: {
                                  fill: "#215796",
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: "#e25241",
                                  stroke: "#215796",
                                  strokeWidth: 0.75,
                                  outline: "none",
                                },
                              }}
                            >
                              <UncontrolledTooltip placement="bottom" delay={0} target={"geo-" + geography.properties.province.replace(/\s/g, '') + "-" + i}>
                                {geography.properties.name}
                              </UncontrolledTooltip>
                            </Geography>
                          ); 
                        }
                      } 
                    })}
                  </Geographies>
                </ZoomableGroup>
              </ComposableMap>
            </div>
            :
            <div className="w-100 mt-5 mx-auto text-center">
              <FontAwesomeIcon icon={faSpinner} size="6x" spin className="text-center text-primary" />
            </div> }
        </CardBody>
      </Card>
    ); 
  }
}

export default Map;
